<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-html="value" />
  </div>
</template>

<script>
import CepService from "../../../../domain/cep/CepService";
import Endereco from "../../../../domain/cep/Endereco";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";

export default {
  name: "view-c-protocolo-cep-empresa",
  props: {
    label: String,
    value: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/CepEmpresa.vue